import React, { Fragment, useEffect, useState } from 'react'
import useStyles from './styles'
import { useSelector, useDispatch } from 'react-redux'
import { Typography, Box, CircularProgress } from '@material-ui/core'
import { isEmpty } from 'lodash'
import AutoSizer from 'react-virtualized-auto-sizer'
import { getEventDonations } from 'actions/event'
import Donation from './Donation'
import Scrollbars from 'react-scrollbars-custom'
import { orderBy } from 'lodash'
import classnames from 'clsx'

const Donations = ({ children }) => {
  const classes = useStyles()
  const orientation = useSelector(state => state.window.orientation)

  const auctionCode = useSelector(state => state.event.event.auction_code)
  const donations = useSelector(state => state.event.donations)
  const event = useSelector(state => state.event.event)

  const dispatch = useDispatch()

  const donationsLoaded = useSelector(state => state.event.donationsLoading)

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      className={classnames(classes.donations, classes[orientation])}
    >
      {event.live_settings.show_engagements && (
        <Fragment>
          {donations.length > 0 && (
            <div className={classes.donationsAutoSizer}>
              <AutoSizer>
                {({ height, width }) => (
                  <Scrollbars
                    style={{
                      height,
                      width: width + 20
                    }}
                    permanentTracks={false}
                  >
                    <Box width="100%" className={classes.donationsList}>
                      {orderBy(donations, 'orderableDate', 'desc').map(
                        donation => (
                          <Donation
                            key={donation.donation_id}
                            donation={donation}
                          />
                        )
                      )}
                    </Box>
                  </Scrollbars>
                )}
              </AutoSizer>
            </div>
          )}
          {donations.length === 0 && donationsLoaded && <Box margin="auto" />}
          {isEmpty(donations) && !donationsLoaded && (
            <Box
              height="100%"
              width="100%"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <CircularProgress style={{ color: 'white' }} />
            </Box>
          )}
        </Fragment>
      )}
    </Box>
  )
}

export default Donations



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/DonationsList/index.jsx